import { useSuspenseQuery } from '@tanstack/react-query'

import { regionaisKeys } from '@/features/regionais/utils/queries'
import { GetUnidadeDeNegocioService } from '@/http/unidade-negocio.service'
import type { TUnidadesDeNegocioDisponiveisResponse } from '@/types/unidade-negocio'
import { UMA_HORA } from '@/utils/constants'

export const useSuspenseRegionais = () => {
  return useSuspenseQuery<TUnidadesDeNegocioDisponiveisResponse>({
    queryKey: regionaisKeys.listas(),
    queryFn: () => new GetUnidadeDeNegocioService().execute().then((response) => response.data),
    staleTime: UMA_HORA,
  })
}
